import {  postRequest } from '@/libs/axios';
export const getPointsRules = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/page', params)
}
export const createPointsRule = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/add', params)
}

export const updatePointsRule = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/update', params)
}

export const deletePointsRule = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/delete', params)
}

export const changeRuleStatus = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/changeRuleStatus', params)
}

export const pointsRuleDetail = (params) => {
    return postRequest('/ndt/module/pointsRebateRules/detail', params)
}
export const getPointsRecords = (params) => {
    return postRequest('/ndt/module/pointsRebateRecord/generate/record', params)
}
export const manualAddPoints = (params) => {
    return postRequest('/ndt/module/pointsRebateRecord/manual/add', params)
}
